<template>
<fullscreen ref="fullscreen"
            @change="fullscreenChange">
  <input v-if="fullscreenEnabled && !fullscreen"
         id="fullscreen-button"
         class="fullscreen-button"
         type="button"
         @click="toggle">
  <input v-if="fullscreenEnabled && fullscreen"
         id="exit-fullscreen-button"
         class="fullscreen-button"
         type="button"
         @click="toggle">
  <div id="netEntGame">
  </div>
</fullscreen>
</template>

<script>
import netentServiceBuilder from '../services/netentService'

// Query params
const queryString = window.location.search
const urlParams = new URLSearchParams(queryString)

// Extracted query params
const gameId = String(urlParams.get('gameId')).replace(/\s/g, '')
const authHeader = String(urlParams.get('authHeader')).replace(/\s/g, '')
const email = String(urlParams.get('email')).replace(/\s/g, '')
const userUuid = String(urlParams.get('userUuid')).replace(/\s/g, '')
const tenantUuid = String(urlParams.get('tenantUuid')).replace(/\s/g, '')
const language = String(urlParams.get('language')).replace(/\s/g, '')
const referrerUrl = String(urlParams.get('referrerUrl')).replace(/\s/g, '')

let netentService = null
let gameInclusionPromise = null

export default {
  name: 'NetentFrame',
  beforeCreate () {
    const netentGameInclusionElement = document.createElement('script')
    netentGameInclusionElement.setAttribute('src', process.env.VUE_APP_NETENT_GAME_INCLUSION_URL)
    document.head.appendChild(netentGameInclusionElement)

    // There is no other way to wait for this script to load...
    gameInclusionPromise = new Promise((resolve, reject) => {
      netentGameInclusionElement.onload = () => {
        netentService = netentServiceBuilder(
          authHeader,
          // eslint-disable-next-line no-undef
          netent
        )
        resolve()
      }
      netentGameInclusionElement.onerror = () => {
        reject(new Error('Failed to load GameInclusion script'))
      }
    })
  },
  destroyed () {
    netentService.closeSession()
  },
  data () {
    return {
      gameId: gameId,
      authHeader: authHeader,
      email: email,
      userUuid: userUuid,
      tenantUuid: tenantUuid,
      language: language,
      fullscreenEnabled: false,
      fullscreen: false
    }
  },
  methods: {
    toggle () {
      if (!this.fullscreenEnabled) { return }
      this.$refs.fullscreen.toggle()
    },
    fullscreenChange (fullscreen) {
      this.fullscreen = fullscreen

      if (this.fullscreen) {
        document.getElementById('netEntGame').classList.add('fullscreen')
      }
    }
  },
  async mounted () {
    await gameInclusionPromise

    window.addEventListener('message', (event) => {
      // Check the content origin. It has to be from one of the NetEnt servers.
      if ((event.origin === process.env.VUE_APP_NETENT_EVENTS_ORIGIN ||
      event.origin === process.env.VUE_APP_NETENT_TEST_EVENTS_ORIGIN) &&
      event.data.includes('goToLobby')) {
        try {
          // eslint-disable-next-line no-undef
          Android.exitGame()
        } catch (ignore) {
          window.location.href = referrerUrl
        }
      }
    }, false)

    if (!this.gameId.includes('not_mobile')) {
      // We're on mobile, but we must check if fullscreen is enabled
      // https://caniuse.com/?search=fullscreenEnabled
      this.fullscreenEnabled = document.fullscreenEnabled || document.mozFullscreenEnabled || document.msFullscreenEnabled
    }

    await netentService.establishSession({
      email: this.email,
      userUuid: this.userUuid,
      tenantUuid: this.tenantUuid,
      language: this.language,
      mobile: !this.gameId.includes('not_mobile')
    },
    {
      gameId: this.gameId,
      userUuid: this.userUuid,
      tenantUuid: this.tenantUuid,
      language: this.language
    },
    function netentLaunchCallback (netentExtend) {
      window.addEventListener('resize', function () {
        netentExtend.resize(window.innerWidth, window.innerHeight)
      })
      netentExtend.addEventListener('gameReady', function () {
        netentExtend.get('volumeLevel', function (volumeLevel) {})
        netentExtend.set('volumeLevel', 50)
        netentExtend.resize(window.innerWidth, window.innerHeight)
      })
    },
    function sessionRefreshFailureCallback (message) {
      if (message === 'isUserSessionAlive') {
        document.getElementById('netEntGame').replaceWith('Session Expired ("isUserSessionAlive" failed')
      } else if (message === 'refreshSession') {
        document.getElementById('netEntGame').replaceWith('Session Expired ("refreshSession" failed')
      }
    })
  }
}

</script>

<style>
*, *:before, *:after {
  box-sizing: border-box;
}

body{
  margin: 0;
  background:black;
}

#netEntGame{
  position: fixed;
  left: 0;
  top: 0;
}

@media (orientation: landscape){
  #netEntGame{
    width: 100%!important;
  }
}

@media (orientation: landscape) and (min-width: 1025px){
  #netEntGame{
    height: calc(100% - 3.75rem)!important;
  }
}

@media (orientation: portrait){
  #netEntGame{
    height: 100%!important;
    width: 100%!important;
  }
}
</style>

<style scoped>
.fullscreen-button {
  background-size: cover !important;
  border: none;
  height: 3.6rem;
  width: 3.6rem;
  margin-bottom: 3.6rem;
  margin-right: 1.0rem;
  position: fixed;
  bottom:0;
  right:0;
}

#fullscreen-button {
  background: url('../assets/enter-fullscreen.png') no-repeat;
}
#fullscreen-button:hover {
  background: url('../assets/enter-fullscreen-hover.png') no-repeat;
}
#exit-fullscreen-button {
  background: url('../assets/exit-fullscreen.png') no-repeat;
}
#exit-fullscreen-button:hover {
  background: url('../assets/exit-fullscreen-hover.png') no-repeat;
}
</style>
